import { CSN_SEARCH_BAR_FACT_TYPE, SEARCH_RESULTS_PAGE, getPageUrl } from '@/utils/analyticsClientHelper';
import { SearchBarFact } from '@/analytics/models/cventAnalytics/SearchBarFact';
import type { MapView } from '@/constants/mapConstants';

// Returns the Search Bar Fact
export function getSearchBarFact(
  searchTerm: string,
  mapView: MapView,
  pageNumber: string | null,
  eventStartDate: string,
  eventEndDate: string,
  guestRoomCount: number | 'null',
  attendeeCount: number | 'null',
  checkInDate: string,
  checkOutDate: string
): SearchBarFact {
  const currentPageNumber = pageNumber != null ? Number(pageNumber) : 1;
  return {
    type: CSN_SEARCH_BAR_FACT_TYPE,
    page: SEARCH_RESULTS_PAGE,
    map_view: mapView,
    current_page_number: currentPageNumber,
    search_term: searchTerm,
    page_url: getPageUrl(),
    eventStartDate,
    eventEndDate,
    attendeeCount,
    guestRoomCount,
    checkInDate,
    checkOutDate
  };
}
